import { Box, CircularProgress, Typography } from "@mui/material";
import EditBasicItemForm from "app/components/EditItem/EditBasicItemForm";
import { PageContainer } from "app/components/PageContainer";
import { useLazyGetItemDetailsQuery } from "lib/features/item/itemService";
import { selectUser } from "lib/features/user/userSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

export default function EditBasicItem() {
  const navigate = useNavigate();
  const { id } = useParams();
  const itemId = id ? parseInt(id, 10) : undefined;
  const user = useSelector(selectUser);

  const [getItemDetails, { data: itemDetails, isLoading }] =
    useLazyGetItemDetailsQuery();

  useEffect(() => {
    if (itemId) {
      getItemDetails(itemId);
    }
  }, [itemId, getItemDetails]);

  useEffect(() => {
    if (
      itemDetails &&
      itemDetails.business &&
      itemDetails?.business?.business_users[0]?.id !== user?.id
    ) {
      navigate(-1);
    }
  }, [itemDetails, navigate, user?.id]);

  return (
    <PageContainer>
      <Box width="100%" position="relative">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "1rem",

            maxWidth: {
              xs: "90vw", // small
              sm: "70vw", // tab
              md: "50vw", // large
            },
            marginRight: "auto",
            marginLeft: "auto",
          }}
        >
          {isLoading ? (
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <CircularProgress />
            </Box>
          ) : itemDetails && itemId ? (
            <>
              {/* Header */}
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    flex: 1,
                    color: "#000",
                    fontWeight: "600",
                    fontSize: "17px",
                    textAlign: "center",
                  }}
                >
                  Edit Item
                </Typography>
                <Typography
                  sx={{ color: "#328734", cursor: "pointer" }}
                  onClick={() => navigate("/my-items")}
                >
                  Cancel
                </Typography>
              </Box>

              {/* Body */}
              <EditBasicItemForm itemDetails={itemDetails} itemId={itemId} />
            </>
          ) : (
            <Typography>No Record Found</Typography>
          )}
        </Box>
      </Box>
    </PageContainer>
  );
}
